const isAuthReducer = (state = { permission: {} }, action) => {
    switch (action.type) {
        case 'SETPERMISSION':
            return { permission: action.permission}
        default:
            return { permission: state.permission};
    }
}

export default isAuthReducer;